import { PreferenceTimeOutput } from '@allocab/allocab-dedicated-driver-types/lib/src/dedicated-driver-preferences/output/dedicated-driver-commons.output';
import { useMemo } from 'react';

import { PreferencesOptions } from './utils';
import { Label } from '../../components/atomic/Label';
import { TrashIcon } from '../../components/icons/TrashIcon';
import { Spinner } from '../../components/Spinner';
import { useDeleteDriverPreferences } from '../../hooks/useDeleteDriverPreferences';
import { t } from '../../services/translation/translation';

type Props = {
  driverKey: string;
  slots?: PreferenceTimeOutput[];
  day: PreferencesOptions;
};

export const DriverPreferencesOfDay = ({ slots, day, driverKey }: Props) => {
  const { mutate: deletePreference, isLoading, context } = useDeleteDriverPreferences(driverKey);

  const sortedSolots = useMemo(
    () =>
      (slots ?? [])?.sort((a, b) =>
        a.start.hours > b.start.hours || (a.start.hours === b.start.hours && a.start.minutes > b.start.minutes)
          ? 1
          : -1,
      ),
    [slots],
  );

  return (
    <div className="">
      <Label className="text-gray-500 dark:text-gray-400">{day.label}</Label>
      {sortedSolots.map(preference => (
        <div key={`${preference.start.hours}-${preference.end.hours}`} className="flex flex-row items-center pl-3 ">
          <div className="font-mono text-sm">
            {t('common.from')} {preference.start.hours.toString().padStart(2, '0')}:
            {preference.start.minutes.toString().padStart(2, '0')} {t('common.to')}
            {preference.end.hours.toString().padStart(2, '0')}:{preference.end.minutes.toString().padStart(2, '0')}
          </div>
          <button
            type="button"
            className="p-1 flex items-center justify-center"
            onClick={() => deletePreference({ day: day.value, time: { start: preference.start, end: preference.end } })}
          >
            {isLoading &&
            JSON.stringify(context?.time.start) === JSON.stringify(preference.start) &&
            JSON.stringify(context?.time.end) === JSON.stringify(preference.end) ? (
              <Spinner />
            ) : (
              <TrashIcon className="w-6 h-6 fill-red-700 dark:fill-red-500" />
            )}
          </button>
        </div>
      ))}

      {sortedSolots.length === 0 ? (
        <div className="italic pl-3 text-gray-500 dark:text-gray-400">{t('common.no-availability')}</div>
      ) : null}
    </div>
  );
};
